import { render, staticRenderFns } from "./RemoveBUFromProject.vue?vue&type=template&id=75bba088&scoped=true&"
import script from "./RemoveBUFromProject.vue?vue&type=script&lang=js&"
export * from "./RemoveBUFromProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bba088",
  null
  
)

export default component.exports